var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "change-lang-wrapper" },
    [
      _c("div", { staticClass: "small-title bold" }, [
        _vm._v(_vm._s(_vm.$t("setting.lang")))
      ]),
      _vm._v(" "),
      _c("change-lang", { staticClass: "setting" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }